export default "__VITE_PUBLIC_ASSET__032cfbee__"